import { render, staticRenderFns } from "./PrivacyPolicyAck.vue?vue&type=template&id=084674ba&"
import script from "./PrivacyPolicyAck.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyAck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports